<!-- Layout principal com cards de segurança no topo e login centralizado -->
<div class="login-container" #loginContainer>
  <!-- Cards de segurança no topo -->
  <div class="security-cards-section">
    <div class="security-cards-container">
      <div class="security-card">
        <span class="icon-group">
          <nb-icon icon="lock-outline" status="success"></nb-icon>
        </span>
        <div class="security-text">
          <h3>Segurança de Dados</h3>
          <p>Seus dados estão protegidos com criptografia de ponta a ponta e protocolos de segurança avançados.</p>
        </div>
      </div>
      
      <div class="security-card">
        <span class="icon-group">
          <nb-icon icon="lock-outline" status="primary"></nb-icon>
        </span>
        <div class="security-text">
          <h3>Proteção de Privacidade</h3>
          <p>Conformidade com LGPD e políticas rigorosas de proteção à privacidade dos usuários.</p>
        </div>
      </div>
      
      <div class="security-card">
        <span class="icon-group">
          <nb-icon icon="award-outline" status="warning"></nb-icon>
        </span>
        <div class="security-text">
          <h3>Experiência e Credibilidade</h3>
          <p>Mais de 10 anos de experiência em soluções financeiras, imobiliárias e pecuárias com foco em segurança e confiança.</p>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Formulário de login centralizado -->
  <div class="login-section">
    <div class="login-form">
      <div class="system-title">
        <h1 id="title" class="system-name">Reno Inteligência</h1>
      </div>

      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Não foi possível entrar</b></p>
        <p class="caption alert-lead">Verifique se o e-mail e a senha estão corretos para esta conta.</p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>

      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Sucesso!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
      </nb-alert>

      <!-- Card de bloqueio para IPs fora do Brasil -->
      <nb-card *ngIf="!isIpAllowed" class="blocked-card">
        <nb-card-body>
          <div class="blocked-content">
            <nb-icon icon="globe-outline" status="danger" size="giant"></nb-icon>
            <h2 class="blocked-title">Acesso Bloqueado</h2>
            <p class="blocked-message">Este sistema está disponível apenas para usuários localizados no Brasil.</p>
            <div class="blocked-details">
              <nb-icon icon="map-outline" status="danger"></nb-icon>
              <span>Seu IP está localizado em: <strong>{{ currentCountry }}</strong></span>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- Formulário de login (visível apenas para IPs do Brasil) -->
      <form *ngIf="isIpAllowed" (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">
        <div class="form-control-group ambiente-group" *ngIf="permitirTrocaAmbiente">
          <label class="label" for="input-ambiente">Ambiente:</label>
          <nb-select
            fullWidth
            size="large"
            shape="semi-round"
            id="input-ambiente"
            name="ambiente"
            [(ngModel)]="ambienteSelecionado"
            (selectedChange)="onAmbienteChange($event)"
            [class.ambiente-dev]="ambienteSelecionado === 'Desenvolvimento'"
            [class.ambiente-hom]="ambienteSelecionado === 'Homologacao'"
            [class.ambiente-prd]="ambienteSelecionado === 'Producao'">
            <nb-option *ngFor="let opcao of opcoesAmbiente" [value]="opcao.valor">
              {{ opcao.rotulo }}
            </nb-option>
          </nb-select>
          <p class="caption ambiente-hint">Login e dados virão do banco deste ambiente.</p>
        </div>

        <div class="form-control-group">
          <label class="label" for="input-email">Endereço de E&ndash;mail:</label>
          <input nbInput
                 fullWidth
                 [(ngModel)]="user.email"
                 #email="ngModel"
                 name="e-mail"
                 id="input-email"
                 pattern=".+@.+\..+"
                 placeholder="Endereço de E&ndash;mail"
                 fieldSize="large"
                 autofocus
                 autocomplete="username"
                 [required]="getConfigValue('forms.validation.email.required')"
                 [attr.aria-invalid]="email.invalid && email.touched ? true : null"
                 tabindex="1"
                 (blur)="sincronizarCamposComTela()"
                 (animationstart)="onPreenchimentoAutomatico($event)">
          <ng-container *ngIf="email.invalid && email.touched">
            <p class="caption status-danger" *ngIf="email.errors?.required && !temEmailVisivel()">
              Preencha seu E&ndash;mail!
            </p>
            <p class="caption status-danger" *ngIf="email.errors?.pattern">
              O e-mail deve ser o verdadeiro!
            </p>
          </ng-container>
        </div>

        <div class="form-control-group">
          <label class="label" for="input-password">Senha:</label>
          <nb-form-field>
            <input nbInput
              fullWidth
              [(ngModel)]="user.password"
              #password="ngModel"
              name="password"
              [type]="hide ? 'password':'text'"
              id="input-password"
              placeholder="Senha"
              fieldSize="large"
              autocomplete="current-password"
              [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
              [required]="getConfigValue('forms.validation.password.required')"
              [minlength]="getConfigValue('forms.validation.password.minLength')"
              [maxlength]="getConfigValue('forms.validation.password.maxLength')"
              [attr.aria-invalid]="password.invalid && password.touched ? true : null"
              tabindex="2"
              (blur)="sincronizarCamposComTela()"
              (animationstart)="onPreenchimentoAutomatico($event)">
            <button nbSuffix nbButton ghost 
              status="basic"
              type="button"
              (click)="togglePasswordVisibility($event)" 
              tabindex="-1"
              class="password-toggle-btn"
              [attr.aria-label]="hide ? 'Mostrar senha' : 'Ocultar senha'">
              <nb-icon [icon]="hide ? 'eye-off-2-outline' : 'eye-outline'"
                      pack="eva">
              </nb-icon>
            </button>
          </nb-form-field>

          <ng-container *ngIf="password.invalid && password.touched ">
            <p class="caption status-danger" *ngIf="password.errors?.required">
              Senha é obrigátoria!
            </p>
            <p class="caption status-danger" *ngIf="password.errors?.minlength || password.errors?.maxlength">
              A senha deve conter
              de {{ getConfigValue('forms.validation.password.minLength') }}
              a {{ getConfigValue('forms.validation.password.maxLength') }}
              caracteres
            </p>
          </ng-container>
        </div>

        <div class="form-control-group accept-group">
          <div class="checkbox-row">
            <div class="left-side">
              <nb-checkbox name="rememberMe" [(ngModel)]="user.rememberMe">Lembrar senha</nb-checkbox>
              <a class="forgot-password caption-2" (click)="onForgotPasswordClick()">Esqueci minha senha?</a>
            </div>
          </div>
        </div>

        <button nbButton
                fullWidth
                status="primary"
                size="large"
                type="submit"
                [disabled]="!podeEntrar"
                [class.btn-pulse]="submitted"
                tabindex="3"
                class="login-btn">
          {{ !isIpValidated ? 'Validando IP...' : 'Entrar' }}
        </button>
      </form>

      <section *ngIf="isIpAllowed && socialLinks && socialLinks.length > 0" class="links" aria-label="Social sign in">
        ou entre com:
        <div class="socials">
          <ng-container *ngFor="let socialLink of socialLinks">
            <a *ngIf="socialLink.link"
               [routerLink]="socialLink.link"
               [attr.target]="socialLink.target"
               [attr.class]="socialLink.icon"
               [class.with-icon]="socialLink.icon">
              <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon"></nb-icon>
              <ng-template #title>{{ socialLink.title }}</ng-template>
            </a>
            <a *ngIf="socialLink.url"
               [attr.href]="socialLink.url"
               [attr.target]="socialLink.target"
               [attr.class]="socialLink.icon"
               [class.with-icon]="socialLink.icon">
              <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon"></nb-icon>
              <ng-template #title>{{ socialLink.title }}</ng-template>
            </a>
          </ng-container>
        </div>
      </section>

      <!-- <section class="another-action" aria-label="Register">
        Não tem conta? <a class="text-link" routerLink="../register">Criar</a>
      </section> -->
    </div>
  </div>
</div>
